export default "__VITE_ASSET__Bkul7LLT__"